module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/18xgQIE/tc-custom/9781460332023.jpg?1724535926054",
      "alt": "This image is the cover for the book Loving the Lawman, Kirkwood Lake"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Loving the Lawman, Kirkwood Lake\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Safe in His Arms "), _c('br'), _c('br'), _vm._v("Widowed and pregnant, Gianna Costanza comes to Kirkwood Lake with her world in pieces. She's determined to put her life back together after her cop husband's death, and romance definitely isn't part of the plan. But when she meets her new landlord and neighbor, she knows she doesn't stand a chance. Deputy Sheriff Seth Campbell is strong and kind, and more supportive than she ever imagined a man could be. Soon he's sweeping Gianna off her feet. But she doesn't know if he's ready for an instant familyor if she's brave enough to love another lawman.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ruth Logan Herne\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Award-winning novelist Ruthy Logan Herne has written over 40 novels and novellas and pinches herself to see if this is real! She lives on a pumpkin farm in Western New York where the long, snowy winters allow Ruthy time to find a quiet spot and write her beautiful, critically acclaimed stories. With over twenty Love Inspired books to her credit, Ruthy loves to connect with her readers on facebook and through her newsletters. Visit ruthloganherne.com or contact at: loganherne@gmail.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0